import { useEffectOnce } from 'react-use';

type NpsAnalyticsProps = Readonly<{
   scriptLink: string;
}>;

export const NpsAnalytics = (props: NpsAnalyticsProps): null => {
   useEffectOnce(() => {
      const scriptElement = document.createElement('script');
      scriptElement.type = 'text/javascript';
      scriptElement.innerHTML = `
<!-- Start of Survicate (www.survicate.com) code -->
(function(w) {
    var s = document.createElement("script");
    s.src = "${props.scriptLink}";
    s.async = true;
    var e = document.getElementsByTagName("script")[0];
    e.parentNode.insertBefore(s, e);
})(window);
<!-- End of Survicate code -->
      `;

      document.head.appendChild(scriptElement);

      return () => {
         document.head.removeChild(scriptElement);
      };
   });

   return null;
};
